import { defineMessages } from 'react-intl';

export const BundleMessages = defineMessages({
  bundlesTitle: {
    id: 'BundleProfilesList.bundlesTitle',
    defaultMessage: 'Bundles',
  },
  bundlesTableIdColumn: {
    id: 'BundlesTable.IdColumn',
    defaultMessage: 'Id',
    description: "Table column header for bundle's unique identifier",
  },
  bundlesTableNameColumn: {
    id: 'BundlesTable.NameColumn',
    defaultMessage: 'Bundle Name',
    description: "Table column header for bundle's name",
  },
  bundlesTableSiteNameColumn: {
    id: 'BundlesTable.SiteNameColumn',
    defaultMessage: 'Site Name',
    description: "Table column header for bundle's site name",
  },
  bundlesTableTubeCountColumn: {
    id: 'BundlesTable.TubeCountColumn',
    defaultMessage: '# of Tubes',
    description: 'Table column header for the number of tubes in a bundle',
  },
  bundlesTableOrganizationColumn: {
    id: 'BundlesTable.OrganizationColumn',
    defaultMessage: 'Organization',
    description: 'Table column header for the organization associated with the bundle',
  },
  bundlesTableUploadDateColumn: {
    id: 'BundlesTable.UploadDateColumn',
    defaultMessage: 'Upload Date',
    description: 'Table column header for date bundle was uploaded',
  },
  errorBundleProfileUpload: {
    id: 'bundleProfilesList.errorBundleProfileUpload',
    defaultMessage: 'Error uploading file. Please try again.',
  },
  bundleProfilesTableEmptyResults: {
    id: 'BundlesTable.emptyResults',
    defaultMessage: 'No bundles have been uploaded. Download, complete, and upload the bundle template to begin.',
  },
  bundlesTableTubeLengthColumn: {
    id: 'BundlesTable.bundlesTableTubeLengthColumn',
    defaultMessage: 'Tube Length',
    description: 'Table column header for the length of the bundle tube',
  },
  bundlesTableTubeDiameterColumn: {
    id: 'BundlesTable.bundlesTableTubeDiameterColumn',
    defaultMessage: 'Tube Diameter',
    description: 'Table column header for the diameter of the bundle tube',
  },
  bundlesTableHeatExchangeModelNumberColumn: {
    id: 'BundlesTable.bundlesTableHeatExchangeModelNumberColumn',
    defaultMessage: 'HX model number',
    description: 'Table column header for the model number of the bundle',
  },
  bundlesTableAssetNumberColumn: {
    id: 'BundlesTable.bundlesTableAssetNumberColumn',
    defaultMessage: 'Asset Number',
    description: 'Table column header for the asset number of the bundle',
  },
  bundlesTablePatternColumn: {
    id: 'BundlesTable.bundlesTablePatternColumn',
    defaultMessage: 'Pattern',
    description: 'Table column header for the pattern of the bundle',
  },
  bundlesTablePitchColumn: {
    id: 'BundlesTable.bundlesTablePitchColumn',
    defaultMessage: 'Pitch',
    description: 'Table column header for the pitch of the bundle',
  },
  bundlesTableSharedColumn: {
    id: 'BundlesTable.bundlesTableSharedColumn',
    defaultMessage: 'Shared',
    description: 'Table column header indicating if the bundle has been shared',
  },
  createdAt: {
    id: 'BundlesModal.createdAt',
    defaultMessage: `Created date`,
  },
  siteName: {
    id: 'BundlesModal.siteName',
    defaultMessage: `Site name`,
  },
  selectASiteName: {
    id: 'bundlesInfo.selectASiteName',
    defaultMessage: 'Select a site name',
  },
  filterBundles: {
    id: 'BundlesModal.filterBundles',
    defaultMessage: 'Filter bundles',
  },
  endOfBundlesListMessage: {
    id: 'BundlesList.endOfBundlesListMessage',
    defaultMessage:
      'You have loaded the maximum number of bundles supported. If a bundle is not present, please adjust the search filters.',
  },
  endOfResultsMessage: {
    id: 'BundlesList.endOfResultsMessage',
    defaultMessage: 'End of bundles matching the search filters.',
  },
  noBundlesFoundMessage: {
    id: 'BundlesList.noBundlesFoundMessage',
    defaultMessage: 'No Bundles match the selected filters',
  },
  noBundlesRecordedMessage: {
    id: 'BundlesList.noBundlesRecordedMessage',
    defaultMessage: 'No Bundles have been recorded yet',
  },
  bundleCardTubeCount: {
    id: 'bundleCard.bundleCardTubeCount',
    defaultMessage: '{tubeCount} Tubes',
    description: 'Shows the number of tubes in a bundle.',
  },
  filter: {
    id: 'BundlesModal.filter',
    defaultMessage: 'Filter',
  },
  bundlesHeader: {
    defaultMessage: 'Bundles',
    id: 'Bundle.bundlesHeader',
  },
  bundleTitleLabel: {
    id: 'Bundle.bundleNameLabel',
    defaultMessage: 'Bundle Title',
  },
  siteNameLabel: {
    id: 'Bundle.siteNameLabel',
    defaultMessage: 'Site',
  },
  organizationLabel: {
    id: 'Bundle.organizationLabel',
    defaultMessage: 'Organization',
  },
  uploadDateLabel: {
    id: 'Bundle.uploadDateLabel',
    defaultMessage: 'Upload Date',
  },
  tubeCountLabel: {
    id: 'Bundle.tubeCountLabel',
    defaultMessage: '# of Tubes',
  },
  tubeLengthLabel: {
    id: 'Bundle.tubeLengthLabel',
    defaultMessage: 'Tube Length',
  },
  tubeDiameterLabel: {
    id: 'Bundle.tubeDiameterLabel',
    defaultMessage: 'Tube Diameter',
  },
  modelNumberLabel: {
    id: 'Bundle.modelNumberLabel',
    defaultMessage: 'HX Model #',
  },
  assetNumberLabel: {
    id: 'Bundle.assetNumberLabel',
    defaultMessage: 'Asset Number',
  },
  patternLabel: {
    id: 'Bundle.patternLabel',
    defaultMessage: 'Pattern',
  },
  pitchLabel: {
    id: 'Bundle.pitchLabel',
    defaultMessage: 'Pitch',
  },
  rotatedLabel: {
    id: 'Bundle.rotatedLabel',
    defaultMessage: 'Rotated',
  },
  downloadTemplateButtonLabel: {
    id: 'BundleList.downloadTemplateButtonLabel',
    defaultMessage: 'Download Bundle Template',
  },
  bundlePremiumFeature: {
    id: 'BundlesTable.bundlePremiumFeature',
    defaultMessage: 'Bundle Profiles is a premium feature.',
  },
  bundleContactStoneAge: {
    id: 'BundlesTable.bundleContactStoneAge',
    defaultMessage: 'Contact StoneAge to learn more.',
  },
  bundleInfoSharedWithLabel: {
    id: 'bundlesInfo.sharedWithLabel',
    defaultMessage: 'Shared Bundle',
  },
  uploadBundleButtonLabel: {
    id: 'BundlesTable.uploadBundleButtonLabel',
    defaultMessage: 'Upload',
  },
  uploadBundleError: {
    id: 'UploadBundle.uploadBundleError',
    defaultMessage: 'An error occurred processing the template file. Check your file and try again.',
  },
  bundleFileRequiredError: {
    id: 'UploadBundle.bundleFileRequiredError',
    defaultMessage: 'A bundle file is required.',
  },
  bundleRotationInvalid: {
    id: 'UploadBundle.bundleRotationInvalid',
    defaultMessage: 'The bundle rotation value is invalid.',
  },
  bundleRotationMissing: {
    id: 'UploadBundle.bundleRotationMissing',
    defaultMessage: 'The bundle rotation value is missing.',
  },
  bundlePatternInvalid: {
    id: 'UploadBundle.bundlePatternInvalid',
    defaultMessage: 'The bundle pattern is invalid.',
  },
  bundleErrorMessageWithRow: {
    id: 'UploadBundle.bundleErrorMessageWithRow',
    defaultMessage: `The issue was detected on line {row} of the file: {message}.`,
    description: '"{row}" and "{message}" are variables that are passed in, do not translate.',
  },
  bundleUploadedInvalidWithError: {
    id: 'UploadBundle.bundleUploadedInvalidWithError',
    defaultMessage:
      'An error occurred when processing the uploaded bundle file. {error} Please check your bundle file and instructions and try again.',
    description: '"{error}" is a variable that is passed in, do not translate.',
  },
  missingRequiredFields: {
    id: 'UploadBundle.missingRequiredFields',
    defaultMessage: 'The following required fields are missing:',
  },
  missingItemsName: {
    id: 'UploadBundle.missingItems.Name',
    defaultMessage: 'Name',
  },
  missingItemsSite: {
    id: 'UploadBundle.missingItems.Site',
    defaultMessage: 'Site',
  },
  missingItemsHxModelNumber: {
    id: 'UploadBundle.missingItems.HXModelNumber',
    defaultMessage: 'HXModelNumber',
  },
  unitRequiredWithTubeLength: {
    id: 'UploadBundle.unitRequiredWithTubeLength',
    defaultMessage: 'Tube length is optional, but if a value is provided, a unit must also be provided.',
  },
  unitRequiredWithTubeDiameter: {
    id: 'UploadBundle.unitRequiredWithTubeDiameter',
    defaultMessage: 'Tube diameter is optional, but if a tube diameter is provided, a unit must also be provided.',
  },
  unitRequiredWithPitch: {
    id: 'UploadBundle.unitRequiredWithPitch',
    defaultMessage: 'Pitch is optional, but if a value is provided, a unit must also be provided.',
  },
  bundleToLargeError: {
    id: 'UploadBundle.bundleToLargeError',
    defaultMessage: 'The selected bundle file is larger than Sentinel Link supports - a 300x300 grid.',
  },
  bundleContainsInvalidTubesWarning: {
    id: 'UploadBundle.bundleContainsInvalidTubesWarning',
    defaultMessage:
      'The bundle file contains tubes that are not formatted correctly to the triangle or square pattern. These tubes will be removed when saved. Please check your bundle file and instructions.',
  },
  uploadBundleTitle: {
    id: 'UploadBundle.title',
    defaultMessage: 'Upload a Bundle',
  },
  bundleFileUploadDescription: {
    id: 'UploadBundle.bundleFileUploadDescription',
    defaultMessage:
      'Attach a .txt or .csv bundle file you’d like to upload. Make sure your inputs are correct as you won’t be able to make edits once uploaded.',
  },
  bundleCreatedSuccessfullyMessage: {
    id: 'Bundle.bundleCreatedSuccessfullyMessage',
    defaultMessage: 'The bundle has been saved.',
  },
  bundleCreatedSuccessfullyHeader: {
    id: 'bundle.AddedSuccessfullyHeader',
    defaultMessage: 'Success!',
  },
  bundleCreateFailedTitle: {
    id: 'Bundle.bundleAddFailedTitle',
    defaultMessage: 'Error Saving',
  },
  bundleCreateFailedMessage: {
    id: 'Bundle.bundleCreateFailedMessage',
    defaultMessage: 'An error occurred saving the bundle. Please try again.',
  },
  deleteBundleTitle: {
    id: 'BundleInfo.deleteBundleTitle',
    defaultMessage: 'Delete Bundle?',
    description: 'Title for the delete bundle warning modal',
  },
  deleteBundleButtonText: {
    id: 'BundleInfo.deleteBundleButtonText',
    defaultMessage: 'Delete Bundle',
    description: 'Label for the delete bundle button.',
  },
  bundleDeletedSuccessfullyMessage: {
    id: 'Bundle.bundleDeletedSuccessfullyMessage',
    defaultMessage: 'Success! Bundle has been deleted.',
  },
  bundleDeletionFailedMessage: {
    id: 'Bundle.bundleDeletionFailedMessage',
    defaultMessage: 'Error! Your bundle could not be deleted. Please try again.',
  },
  bundlePreviewTitle: {
    id: 'Bundle.bundlePreview',
    defaultMessage: 'Bundle Preview',
  },
  shareBundle: {
    id: 'BundleInfo.shareBundle',
    defaultMessage: 'Share Bundle',
  },
  unshareBundle: {
    id: 'BundleInfo.unshareLog',
    defaultMessage: 'Unshare Bundle',
  },
  shareBundleSuccessMessage: {
    id: 'BundleInfo.shareBundleSuccessMessage',
    defaultMessage: 'Success! This bundle has successfully been shared with {orgName}.',
    description: '"{orgName}" is a variable that is passed in, do not translate.',
  },
  shareFailureMessage: {
    id: 'BundleInfo.shareFailureMessage',
    defaultMessage: 'Error! This bundle was not shared successfully.',
  },
  unshareBundleSuccessMessage: {
    id: 'BundleInfo.unshareBundleSuccessMessage',
    defaultMessage: 'Success! This bundle is no longer shared with {orgNames}.',
    description: '"{orgNames}" is a variable that is passed in, do not translate.',
  },
  unshareFailureMessage: {
    id: 'BundleInfo.unshareFailureMessage',
    defaultMessage: 'Error! Failed to un-share the bundle. Please try again.',
  },
  organizationPlaceholder: {
    id: 'BundleInfo.organizationPlaceholder',
    defaultMessage: 'Select an organization',
  },
  familyOrganizationSelectLabel: {
    id: 'BundleInfo.familyOrganizationSelectLabel',
    defaultMessage: 'Select a Family Organization',
  },
  organizationSelectLabel: {
    id: 'BundleInfo.organizationSelectLabel',
    defaultMessage: 'Select an Organization',
  },
  requiredFieldMessage: {
    id: 'BundleInfo.requiredFieldMessage',
    defaultMessage: 'This field is required!',
  },
  unshareBundleDescription: {
    id: 'BundleInfo.unshareBundleDescription',
    defaultMessage: 'Select who you want to unshare this bundle with. They will no longer be able to view this bundle.',
  },
  bundleInfoSubHeading: {
    id: 'BundleInfo.bundleInfoSubHeading',
    defaultMessage: 'Created by {userName} on {date}',
    description: 'Label for created by info. UserName and date should not be translated.',
  },
  notesLabel: {
    id: 'Bundle.notesLabel',
    defaultMessage: 'Notes',
  },
  sharedBundlesDefaultLabel: {
    id: 'BundleInfo.sharedBundlesDefaultLabel',
    defaultMessage: 'No',
  },
  bundleProfileLabel: {
    id: 'UpdateJobDetails.bundleProfileLabel',
    defaultMessage: 'Bundle Profile',
  },
  selectBundleProfileLabel: {
    id: 'UpdateJobDetails.selectBundleProfileLabel',
    defaultMessage: 'Select a bundle profile',
  },
  bundleProfilesLabel: {
    id: 'UpdateJobDetails.bundleProfilesLabel',
    defaultMessage: 'Bundle Profiles',
  },
  resetBundleSelectionButtonLabel: {
    id: 'UpdateJobDetails.resetBundleSelectionButtonLabel',
    defaultMessage: 'Clear Selection',
    description: 'Label for the clear bundle selection button.',
  },
  bundleDownloadError: {
    id: 'UpdateJobDetails.bundleDownloadError',
    defaultMessage: 'Bundle profile failed to load. Try again or reset your selection and skip bundle download.',
  },
  installButton: {
    id: 'Bundle.installButton',
    defaultMessage: 'Install',
  },
  installProgressLabel: {
    id: 'Bundle.installProgressLabel',
    defaultMessage: 'Installing',
  },
  installSuccess: {
    id: 'Bundle.installSuccess',
    defaultMessage: 'Success! {bundleName} has been installed.',
  },
  installFailure: {
    id: 'Bundle.installFailure',
    defaultMessage: 'Failed to install bundle to controller: {bundleName}',
    description: '"{bundleName}" is a variable that is passed in, do not translate.',
  },
  uninstallButton: {
    id: 'Bundle.uninstallButton',
    defaultMessage: 'Uninstall',
  },
  uninstallSuccess: {
    id: 'Bundle.uninstallSuccess',
    defaultMessage: 'Success! {bundleName} has been removed.',
    description: '"{bundleName}" is a variable that is passed in, do not translate.',
  },
  uninstallFailure: {
    id: 'Bundle.uninstallFailure',
    defaultMessage: 'Failed to remove bundle from controller: {bundleName}',
    description: '"{bundleName}" is a variable that is passed in, do not translate.',
  },

  // Bundle instructions title
  bundleInstructionsTitle: {
    id: 'BundleInstructions.title',
    defaultMessage: 'Using Bundle Templates',
  },
  bundleInstructionsSubtitle: {
    id: 'BundleInstructions.subtitle',
    defaultMessage:
      'Bundle templates are used to pre-program jobs. They provide a simple, efficient, visual way to specify tubes to clean.',
  },

  // Bundle instructions section 1
  bundleInstructionsSection1Title: {
    id: 'BundleInstructions.section1Title',
    defaultMessage: 'Download the Sentinel Link Bundle Template',
  },
  bundleInstructionsSection1Line1: {
    id: 'BundleInstructions.bundleInstructionsSection1Line1',
    defaultMessage:
      'The downloaded zip file contains the bundle template (an Excel file) and a printable PDF of template instructions. Once downloaded, unzip and extract the files to the desired location on your computer.',
  },

  // Bundle instructions section 2
  bundleInstructionsSection2Title: {
    id: 'BundleInstructions.section2Title',
    defaultMessage: 'Unblock and Enable Macros Before Opening the Bundle Template',
  },
  bundleInstructionsSection2Line1: {
    id: 'BundleInstructions.bundleInstructionsSection2Line1',
    defaultMessage: 'Browse to the workbook in File Explorer.',
  },
  bundleInstructionsSection2Line2: {
    id: 'BundleInstructions.bundleInstructionsSection2Line2',
    defaultMessage: 'Right-click the file and select ‘Properties’ from the context menu.',
  },
  bundleInstructionsSection2Line3: {
    id: 'BundleInstructions.bundleInstructionsSection2Line3',
    defaultMessage: 'In the ‘Properties’ window, check ‘Unblock’, and ‘OK’.',
  },
  bundleInstructionsSection2Line4: {
    id: 'BundleInstructions.bundleInstructionsSection2Line4',
    defaultMessage:
      'Open the file and select ‘Enable Macros’ when prompted. (Macros are required for the tube auto-naming feature.)',
  },

  // Bundle instructions section 3
  bundleInstructionsSection3Title: {
    id: 'BundleInstructions.bundleInstructionsSection3Title',
    defaultMessage: 'Familiarize with the Bundle Template / Complete Fields',
  },
  bundleInstructionsSection3Subtitle1: {
    id: 'BundleInstructions.bundleInstructionsSection3Subtitle1',
    defaultMessage: 'Required Information',
  },
  bundleInstructionsSection3Line1: {
    id: 'BundleInstructions.bundleInstructionsSection3Line1',
    defaultMessage: 'Required information is denoted at the top of the bundle template and includes:',
  },
  bundleInstructionsSection3Line2: {
    id: 'BundleInstructions.bundleInstructionsSection3Line2',
    defaultMessage: 'Title',
  },
  bundleInstructionsSection3Line3: {
    id: 'BundleInstructions.bundleInstructionsSection3Line3',
    defaultMessage: 'Site',
  },
  bundleInstructionsSection3Line4: {
    id: 'BundleInstructions.bundleInstructionsSection3Line4',
    defaultMessage: 'HX Model #',
  },
  bundleInstructionsSection3Line5: {
    id: 'BundleInstructions.bundleInstructionsSection3Line5',
    defaultMessage: 'Pattern (select square or triangle)',
  },
  bundleInstructionsSection3Line6: {
    id: 'BundleInstructions.bundleInstructionsSection3Line6',
    defaultMessage: 'Rotation (select yes or no)',
  },
  bundleInstructionsSection3Subtitle2: {
    id: 'BundleInstructions.bundleInstructionsSection3Subtitle2',
    defaultMessage: 'Recommended Information',
  },
  bundleInstructionsSection3Subsection2Line1: {
    id: 'BundleInstructions.bundleInstructionsSection3Subsection2Line1',
    defaultMessage:
      'The remaining options may be left empty, but we recommend completing as much information as you can. The notes section, in particular, helps to identify correct bundles for the job being completed.',
  },
  bundleInstructionsSection3Subtitle3: {
    id: 'BundleInstructions.bundleInstructionsSection3Subtitle3',
    defaultMessage: 'Pattern Definition',
  },
  bundleInstructionsSection3Subsection3Line1: {
    id: 'BundleInstructions.bundleInstructionsSection3Subsection3Line1',
    defaultMessage:
      'The bundle pattern will be created in the blank area below row 15 of the template. Please complete all information before defining your pattern.',
  },
  bundleInstructionsSection3Subtitle4: {
    id: 'BundleInstructions.bundleInstructionsSection3Subtitle',
    defaultMessage: 'Template Dropdown Options',
  },
  bundleInstructionsSection3Subsection4Caption1: {
    id: 'BundleInstructions.bundleInstructionsSection3Subsection4Caption1',
    defaultMessage:
      'Above: Use the dropdowns that are available in the pattern and rotation fields to make a selection.',
  },
  bundleInstructionsSection3Subsection4Caption2: {
    id: 'BundleInstructions.bundleInstructionsSection3Subsection4Caption2',
    defaultMessage:
      'Above: Use the dropdowns that are available in the tube length, tube diameter, and pitch fields to make a unit of measure selection.',
  },

  // Bundle instructions section 4
  bundleInstructionsSection4Title: {
    id: 'BundleInstructions.bundleInstructionsSection4Title',
    defaultMessage: 'Defining a Bundle Pattern',
  },
  bundleInstructionsSection4Line1: {
    id: 'BundleInstructions.bundleInstructionsSection4Line1',
    defaultMessage:
      'Use the area below row 15 in the template file to create your bundle pattern. When marking tube position, leave a space between tubes. Do not leave a space between rows.',
  },
  bundleInstructionsSection4Subsection1Title: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection1Title',
    defaultMessage: 'Automatic Name Assignment',
  },
  bundleInstructionsSection4Subsection1Line1: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection1Line1',
    defaultMessage:
      'If you would like to automatically name the tubes, create the bundle pattern using any placeholder character, for example, an ‘x’, then click the “Set Tube Names” button on the bottom right of the template.',
  },
  bundleInstructionsSection4Subsection2Title: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection2Title',
    defaultMessage: 'Naming Tubes',
  },
  bundleInstructionsSection4Subsection2Line1: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection2Line1',
    defaultMessage:
      'Tube naming is optional! You may name individual tubes manually in each cell or use automatic name assignment. Entering your own names will be slower, and only for your organization’s internal reference.',
  },
  bundleInstructionsSection4Subsection3Title: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection3Title',
    defaultMessage: 'How it Works',
  },
  bundleInstructionsSection4Subsection3Line1: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection3Line1',
    defaultMessage:
      'The cleaning path will begin at the top left and snake down, row by row. Empty spaces are required between tubes to be cleaned',
  },
  bundleInstructionsSection4Subsection4Title: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection4Title',
    defaultMessage: 'Mirroring Tube Maps',
  },
  bundleInstructionsSection4Subsection4Line1: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection4Line1',
    defaultMessage:
      'The bundle template allows you to mirror positions in a partially defined, symmetrical shape in order to help speed up tube definition. You can mirror any quadrant or half of a pattern',
  },
  bundleInstructionsSection4Subsection4Line2: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection4Line2',
    defaultMessage: 'Mirror left to right (far right column is the pivot point and not mirrored)',
  },
  bundleInstructionsSection4Subsection4Line3: {
    id: 'BundleInstructions.bundleInstructionsSection4Subsection4Line3',
    defaultMessage: 'Mirror top to bottom (bottom row is the pivot point and not mirrored)',
  },
  bundleInstructionsSection4Caption1: {
    id: 'BundleInstructions.bundleInstructionsSection4Caption1',
    defaultMessage: 'Above: Example of a square pattern',
  },
  bundleInstructionsSection4Caption2: {
    id: 'BundleInstructions.bundleInstructionsSection4Caption2',
    defaultMessage: 'Above: Example of a triangle pattern',
  },
  bundleInstructionsSection4Caption3: {
    id: 'BundleInstructions.bundleInstructionsSection4Caption3',
    defaultMessage: 'Above: Automatic tube name assignment',
  },
  bundleInstructionsSection4Caption4: {
    id: 'BundleInstructions.bundleInstructionsSection4Caption4',
    defaultMessage: 'Above: Mirroring the tube map',
  },

  // Bundle instructions section 5
  bundleInstructionsSection5Title: {
    id: 'BundleInstructions.bundleInstructionsSection5Title',
    defaultMessage: 'Save the Modified Bundle Template as a Tab-delimited Text file',
  },
  bundleInstructionsSection5Line1: {
    id: 'BundleInstructions.bundleInstructionsSection5Line1',
    defaultMessage:
      'First, save the file, as is, to use as a starting point for future updates. Next, save a copy by going to ‘File’ and select ‘Save As’. Select ‘Tab-delimited Text’ file from the save as dropdown',
  },

  // Bundle instructions section 6
  bundleInstructionsSection6Title: {
    id: 'BundleInstructions.bundleInstructionsSection6Title',
    defaultMessage: 'In the Sentinel Link Web App: Upload the Template in the ‘Bundle’ View',
  },
  bundleInstructionsSection6Subsection1Title: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection1Title',
    defaultMessage: 'Uploading Files',
  },
  bundleInstructionsSection6Subsection1Line1: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection1Line1',
    defaultMessage:
      'The bundle upload button is at the top right of the bundle view. Uploading the file will create a bundle record that is available in both the web and mobile app. Uploaded files should be available in the mobile app almost immediately.',
  },
  bundleInstructionsSection6Subsection2Title: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection2Title',
    defaultMessage: 'Troubleshooting',
  },
  bundleInstructionsSection6Subsection2Line1: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection2Line1',
    defaultMessage: 'When uploading, the web app will warn you if there are issues with a bundle file. For example,',
  },
  bundleInstructionsSection6Subsection2Line2: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection2Line2',
    defaultMessage: 'Required fields are not complete',
  },
  bundleInstructionsSection6Subsection2Line3: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection2Line3',
    defaultMessage: 'The shape defined is not a real shape',
  },
  bundleInstructionsSection6Subsection2Line4: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection2Line4',
    defaultMessage: 'There are no spaces between tubes to be cleaned',
  },
  bundleInstructionsSection6Subsection3Title: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection3Title',
    defaultMessage: 'Managing Bundles',
  },
  bundleInstructionsSection6Subsection3Line1: {
    id: 'BundleInstructions.bundleInstructionsSection6Subsection3Line1',
    defaultMessage:
      'To make changes to a bundle, delete it in the web app, modify the bundle template (Excel file), and re-upload it as a new bundle.',
  },

  // Bundle instructions section 7
  bundleInstructionsSection7Title: {
    id: 'BundleInstructions.bundleInstructionsSection7Title',
    defaultMessage: 'In the Sentinel Link Mobile App: Install the Bundle onto a Controller',
  },
  bundleInstructionsSection7Line1: {
    id: 'BundleInstructions.bundleInstructionsSection7Line1',
    defaultMessage:
      'In order to use a bundle in a job you must install it to the controller via the mobile app. You must be connected to a controller to install bundles.',
  },
  bundleInstructionsSection7Line2: {
    id: 'BundleInstructions.bundleInstructionsSection7Line2',
    defaultMessage:
      'Bundles can be installed from the ‘Jobs > Bundles’ view. Installed bundles will be highlighted, and may be uninstalled.',
  },
  bundleInstructionsSection7Line3: {
    id: 'BundleInstructions.bundleInstructionsSection7Line3',
    defaultMessage:
      'Alternatively, you can review all bundles that are installed onto a connected controller via the ‘Controllers’ view of the mobile app.',
  },

  bundleInstructionsSupportTitle: {
    id: 'BundleInstructions.bundleInstructionsSupportTitle',
    defaultMessage: 'StoneAge Support',
  },
  bundleInstructionsSupportLine1: {
    id: 'BundleInstructions.bundleInstructionsSupportLine1',
    defaultMessage:
      'Still having trouble? Our experienced support team is here to help. We quickly respond to inquiries and provide professional advice to ensure the success of your waterblasting challenges.',
  },

  bundleInfoHeader: {
    id: 'Bundles.bundleInfoHeader',
    defaultMessage: 'New to bundles?',
  },
  bundleInfoDescription: {
    id: 'Bundles.bundleInfoDescription',
    defaultMessage: 'Bundle templates are instructions used to pre-program AUTOCLEAN jobs.',
  },
  bundleInfoDescriptionLink: {
    id: 'Bundles.bundleInfoDescriptionLink',
    defaultMessage: 'Learn More',
  },
  missingInformation: {
    id: 'Bundle.missingInformation',
    defaultMessage: 'Missing Details',
  },
  missingInformationDetails: {
    id: 'Bundle.missingInformationDetails',
    defaultMessage: 'You may be offline or the file cannot be found in the Sentinel Link system.',
  },
  uninstallMissingConfirmation: {
    id: 'Bundle.uninstallMissingConfirmation',
    defaultMessage:
      'Uninstall "{bundleName}"? This bundle may not exist in Sentinel Link, and the bundle data may not be recoverable.',
    description: '"{bundleName}" is a variable that is passed in, do not translate.',
  },
  patternTriangle: {
    id: 'Bundle.patternTriangle',
    defaultMessage: 'Triangle',
  },
  patternSquare: {
    id: 'Bundle.patternSquare',
    defaultMessage: 'Square',
  },
  bundleChartInfoMobile: {
    id: 'BundleChart.infoMobile',
    defaultMessage: 'Pinch to zoom in and out.',
  },
  bundleChartInfoWeb: {
    id: 'BundleChart.infoWeb',
    defaultMessage: 'CTRL button + scroll wheel or pinch on touchpad to zoom. Double-click to reset.',
  },
});
